<template>
    <div class="header--wrapper">
        <div class="gradient-box">
        </div>
        <div class="header--slider-wrapper">
            <div class="slider-background">
                <div class="header--slider">
                    <FullWidthSlider>
                        <img src="/static/img/landing_page/slider_img/slider_0.jpg" alt="">
                        <img src="/static/img/landing_page/slider_img/slider_1.jpg" alt="">
                        <img src="/static/img/landing_page/slider_img/slider_2.jpg" alt="">
                    </FullWidthSlider>
                </div>
            </div>
        </div>
        <div class="container-grid">
            <div class="header--info">
                <div class="header--info__copy">
                    <h1 class="heading--xl text-left heading">START<br/>NEW GAME+</h1>
                    <p class="paragraph text-left">
                        Your mission, should you choose to accept it, is to help create truly original video
                        games
                        for
                        some
                        of the most passionate communities in gaming. Join our international family of Bohemians
                        and
                        become
                        part of a place where curiosity, creativity, and hard work unite — resulting in a team
                        effort
                        we
                        can be proud of for the rest of our lives.
                    </p>
                    <div class="button-wrapper">
                        <bi-button tag="router-link" to="/positions" class="learn-button" size="md">
                            View Open positions
                        </bi-button>
                    </div>
                </div>
                <div class="scroll-down-button">
                    <!--TODO: move button styling somewhere-->
                    <button class="button" v-scroll-to="{ element: '#featured-positions', duration: 1000 }"><i
                            class="icons8-arrow-up-slider--01"></i></button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import BiButton from "@bistudio/bohemia-vue-components/dist/BiButton";
  import "@bistudio/bohemia-vue-components/dist/BiButton/BiButton.css";
  import Label from "../common/Label";
  import FullWidthSlider from "../sliders/FullWidthSlider";

  export default {
    components: {
      FullWidthSlider,
      Label,
      BiButton
    },
    name: "MainHeader"
  };
</script>

<style scoped lang="scss" type="text/scss">
    @import "../../assets/scss/main";
    @import "../../assets/scss/globals";

    $bg-color: #ffffff;
    $dot-color: rgba(77, 77, 77, 0.1);
    $header-overlap: 1700px;

    // Dimensions
    $dot-size: 2px;
    $dot-space: 12px;
    .tns-carousel-arrows {
        display: flex;
        justify-content: flex-end;
        margin-right: 20%;
    }

    .scroll-down-button {
        @media(max-width: 1500px) {
            display: none;
        }
        position: absolute;
        left: 0;
        bottom: -50%;

        button {
            transform: rotateZ(180deg);

            i {
                font-size: 28px;
            }
        }
    }

    .slider-btn {
        background-color: #000;
        width: 54px;
        height: 56px;
        border: none;
        color: white;
        outline: none;

        @media (max-width: $tablet) {
            display: none;
        }
    }

    .prev {
        background-color: $silver;
    }

    .button {
        i {
            font-size: 24px;
        }
    }

    .header--wrapper {
        position: relative;
        min-height: 991px;
        margin: auto;
        max-width: 1920px;
        padding-top: 120px;
        display: flex;
        justify-content: center;
        background-color: $background;
        background: url("/static/img/landing_page/backgrounds/left_terrain_panel.png");
        background-repeat: no-repeat;
        background-size: 43% 100%;
        @media (max-width: 1400px) {
            padding-top: 90px;
        }
        @media (max-width: $tablet) {
            min-height: 100%;
        }
        @media (max-width: 768px) {
            flex-wrap: wrap;
            justify-content: flex-end;
            background-size: 100% 100%;
            background-image: linear-gradient(to top, #fbb03b 0%, #f44d52 100%);
        }

        @media (max-width: $compact) {
            background-image: url('/static/img/landing_page/mobile/background_comp_start_mobile.png');
        }
    }

    .header--info {
        width: 50%;
        position: relative;
        font-size: 90px;
        word-wrap: break-word;
        @media (max-width: 768px) {
            width: 100%;
        }
    }

    .header--slider-wrapper {
        top: 0;
        position: absolute;
        z-index: 1;
        right: 0;
        width: 60%;
        height: 100%;
        background: #fff;

        .slider-background {
            position: absolute;
            z-index: 1;
            padding-top: 120px;
            right: 0;
            top: 0;
            height: 100%;
            max-height: 919px;
            background: radial-gradient($dot-color 20%, rgba(0, 0, 0, 0) 16%), radial-gradient($dot-color 15%, rgba(0, 0, 0, 0) 16%), $bg-color;
            background-position: 16px 16px, 16px 16px;
            -webkit-background-origin: padding-box;
            background-origin: padding-box;
            -webkit-background-clip: border-box;
            background-clip: border-box;
            -webkit-background-size: 12px 12px;
            background-size: 12px 12px;
            @media (max-width: 1400px) {
                padding-top: 90px;
            }
            @media (max-width: 768px) {
                padding-top: 0px;
                position: relative;
            }
        }

        @media (max-width: 1700px) {
            width: 70%;
        }
        @media (max-width: 1450px) {
            width: 85%;
        }
        @media (max-width: 1200px) {
            width: 95%;
        }
        @media (max-width: 768px) {
            position: relative;
            width: 86%;
        }

        @media (max-width: $compact) {
            top: -30px;
        }

    }

    .header--slider {
        @media (max-width: $tablet) {
            z-index: 2;
            right: 0;
        }
    }

    .heading {
        color: $text-strong;
        @media (max-width: $tablet) {
            font-size: 50px;
        }
        @media (max-width: 768px) {
            margin-top: -124px;
            font-size: 38px;
        }
        @media (max-width: $compact) {
            margin-top: -48px;
        }
    }

    .paragraph {
        padding-top: 2em;
        @media (max-width: $tablet) {
            padding-top: 1em;
            font-size: 14px;
        }
    }

    .gradient-box {
        width: 50%;
        height: 600px;
        background-image: linear-gradient(to top, #fbb03b 0%, #f44d52 100%);
        opacity: 0.9;
        z-index: 2;
        position: absolute;
        top: 120px;
        left: 0;
        @media (max-width: 1400px) {
            top: 90px;
        }
        @media (max-width: $tablet) {
            height: 100%;
            top: 0;
        }
        @media (max-width: 768px) {
            display: none;
        }

        @media (max-width: $compact--sm) {
            height: 80vh;
            top: -1.9em;
        }

        @media (max-width: 375px) {
            height: 80vh;
            top: -1.68em;
        }

        @media (max-width: 320px) {
            height: 80vh;
            top: -1.43em;
        }
    }

    .header--info__copy {
        position: relative;
        z-index: 3;
        max-width: 100%;
        padding-right: 50px;
        margin-top: 51px;

        @media (max-width: 1440px) {
            max-width: 100%;
            left: 0;
            padding: 30px;

        }

        @media (max-width: $tablet) {
            max-width: 100%;
            left: 0;
            padding: 27px;
            margin-top: 0;
        }
    }

    .header--container {
        @media (max-width: $tablet) {
            margin-top: 10%;
        }

        @media (max-width: $compact) {
            margin-top: 0%;
        }
    }

    .container-grid {
        max-width: 1200px;
        @media (max-width: $tablet) {
            margin-top: 0 !important;
            margin-bottom: 0 !important;

        }

    }
</style>



// WEBPACK FOOTER //
// src/components/landingPageComponents/MainHeader.vue